import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  init() {
    const nav = new Nav(document.getElementById('nav'));
  }
}
